import { Schemas } from "@kollectivia/shared";
import { useTranslation } from "react-i18next";

import { WrappingNativeSelect } from "./WrappingNativeSelect";

export function CoverageChoice({
  id,
  value,
  readOnly,
  error,
  relatedErrorId,
  helpId,
  onChange,
  onBlur,
}: {
  id: string;
  value: string;
  readOnly: boolean;
  error: string | null;
  relatedErrorId?: string;
  helpId?: string;
  onChange: (value: string) => void;
  onBlur: () => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="min-w-0">
      <label htmlFor={id} className="block text-xs font-medium text-slate-600">
        {t("census.fields.coverage_choice")}
      </label>
      {readOnly ? (
        <p id={id} className="mt-1 whitespace-pre-wrap break-words text-sm text-slate-900">
          {value ? t(`census.coverage_options.${value}`) : t("census.coverage_original")}
        </p>
      ) : (
        <WrappingNativeSelect
          displayValue={
            value
              ? Schemas.CENSUS_COVERAGE_CHOICES.some((choice) => choice === value)
                ? t(`census.coverage_options.${value}`)
                : value
              : t("census.coverage_original")
          }
          id={id}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onBlur={onBlur}
          aria-invalid={error || relatedErrorId ? true : undefined}
          aria-describedby={`${helpId ?? `${id}-help`}${error ? ` ${id}-error` : ""}${relatedErrorId ? ` ${relatedErrorId}` : ""}`}
          className="mt-1"
        >
          <option value="">{t("census.coverage_original")}</option>
          {value && !Schemas.CENSUS_COVERAGE_CHOICES.some((choice) => choice === value) && (
            <option value={value} disabled>
              {value}
            </option>
          )}
          {Schemas.CENSUS_COVERAGE_CHOICES.map((choice) => (
            <option key={choice} value={choice}>
              {t(`census.coverage_options.${choice}`)}
            </option>
          ))}
        </WrappingNativeSelect>
      )}
      {!helpId && (
        <p id={`${id}-help`} className="mt-1 break-words text-xs text-slate-600">
          {t("census.coverage_help")}
        </p>
      )}
      {error ? (
        <p id={`${id}-error`} className="mt-1 text-xs text-red-600">
          {error}
        </p>
      ) : null}
    </div>
  );
}
